module.exports = __webpack_public_path__ + "img/5-m.eacbeb05.jpg";